exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div__DialogueOverlay {\n  background-color: rgba(0, 0, 0, 0.9);\n  width: 100vw;\n  height: 100vh;\n  z-index: 999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  margin: 0;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);

// exports
